export default __webpack_public_path__ + "static/media/uu_logo.ef69094a.png";